.checkbox {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  min-height: var(--target-min);
  padding: var(--space-2) 0;
  color: var(--color-content-primary);
  font: var(--type-body);
  cursor: pointer;
}

.box {
  display: grid;
  flex: none;
  place-items: center;
  width: 22px;
  height: 22px;
  margin-top: 1px;
  border: var(--border-strong) solid var(--color-border-default);
  border-radius: var(--radius-small);
  background: var(--color-bg-surface);
  color: transparent;
  transition:
    background-color var(--motion-fast) var(--motion-ease),
    border-color var(--motion-fast) var(--motion-ease);
}

.checkbox[data-hovered] .box {
  border-color: var(--color-border-strong);
}

.checkbox[data-selected] .box {
  border-color: var(--color-action-primary-bg);
  background: var(--color-action-primary-bg);
  color: var(--color-action-primary-fg);
}

.checkbox[data-focus-visible] .box {
  outline: var(--border-strong) solid var(--color-focus-ring);
  outline-offset: 2px;
  box-shadow: 0 0 0 2px var(--focus-ring-inner, var(--color-bg-surface));
}

.checkbox[data-disabled] {
  opacity: 0.55;
  cursor: not-allowed;
  color: var(--color-content-tertiary);
}

.checkbox[data-disabled] .box {
  border-color: var(--color-border-subtle);
  background: var(--color-bg-subtle);
}

.label {
  max-width: 72ch;
}
